import axiosInstance from 'shared/services/api/axiosInstance';

/**
 * One row per conversation *session*, honouring the Runs tab's time range and
 * filters. `conversation_id` is a thread key that an SDK may reuse for days, so
 * the server splits each thread on an inactivity gap; a row is one sitting.
 */
export async function listConversations({ teamId, timeRange, modularFilters = [], q = '', limit = 50, offset = 0 }) {
  const params = { team_id: teamId, limit, offset };
  if (q) params.q = q;
  if (timeRange?.from) params.time_start = timeRange.from;
  if (timeRange?.to) params.time_end = timeRange.to;
  if (modularFilters.length) params.modularFilters = JSON.stringify(modularFilters);
  const { data } = await axiosInstance.get('/agent-runs/conversations', { params });
  return {
    conversations: data?.conversations || [],
    total: data?.total ?? null,
    hasMore: !!data?.hasMore,
    sessionGapMinutes: data?.sessionGapMinutes ?? null,
  };
}

/**
 * Every run in one conversation session, oldest first, with input/output.
 *
 * Scope it to a single sitting with `from`/`to` (the list row's first/last run),
 * or with `around` (a run's own timestamp) when you know the thread but not
 * which sitting — that's the run drawer's case. Passing neither returns the
 * whole thread.
 */
export async function getConversation({ teamId, conversationId, from, to, around }) {
  const params = { team_id: teamId };
  if (from) params.from = from;
  if (to) params.to = to;
  if (!from && !to && around) params.around = around;
  const { data } = await axiosInstance.get(
    `/agent-runs/conversations/${encodeURIComponent(conversationId)}`,
    { params },
  );
  return { conversation: data?.conversation || null, runs: data?.runs || [] };
}
